import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters, tabs } from "./config";

import useIsMobile from "../../hooks/useIsMobile";

import { TableTitle } from "../../utils/Common"

import BillStats from "./Components/Stats";

const BillList = () => {

  const { isMobile } = useIsMobile();

  return (
    <>
    <TableTitle><InventoryRoundedIcon /><span>Bill List</span></TableTitle>
    {!isMobile ? <BillStats /> : null}
    <Table tableId="bills" title="Bill" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-date" idKey="bill_id" fieldsToSearch={["Vendor"]} NoTitle={true} tabs={tabs} tabField="paid_status" />
    </>
  );
};

export default BillList;